import { HeadersBuilder } from "./HeadersBuilder";
import { UrlQueryBuilder } from "./UrlQueryBuilder";

export class UrlQueryOrHeaderBuilder {
    constructor(private uqBuilder: UrlQueryBuilder, private headersBuilder: HeadersBuilder, private settings: { headersPrefix?: string; maxQSParamLenght?: number } = {}) {
        if (settings.headersPrefix == undefined)
            settings.headersPrefix = "X-TSC-";
        if (settings.maxQSParamLenght == undefined)
            settings.maxQSParamLenght = 500;
    }

    public set(name: string, value: any, isDefaultValue?: (value: any) => boolean, encode: boolean = true): void {
        if ((value != undefined) && (!isDefaultValue || !isDefaultValue(value))) {
            const v = typeof value === "string" ? value : String(value);
            if (v.length > this.settings.maxQSParamLenght!)
                this.headersBuilder.set(this.settings.headersPrefix + name, encode ? encodeURIComponent(value) : value);
            else
                this.uqBuilder.set(name, value);
        }
    }
}
